// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer_Footer__1g4L9","Segment":"footer_Segment__2cocc"};